import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams} from 'navigation/Routes';
import {ComingSoon} from 'components/common/comingSoon';

export function ReportManager({
  navigation,
}: NativeStackScreenProps<RootNavigatorParams>) {
  return (
    <ComingSoon
      text="Gain valuable insights with real-time analytics to optimize team performance and decision-making"
      imageSource={require('assets/illustrations/coming-soon-reports.png')}
    />
  );
}
